import {
  getMainAccountableBank,
  getTaxSavingsAccountableBank,
} from 'components/pages/Banks/Wallet/helpers';
import type { Connector } from 'types/transactions.types';
import useGetConnectors from './useGetConnectors';

const useAccountableBanks = () => {
  const { data: connectors, isLoading: isLoadingConnectors } =
    useGetConnectors();

  const mainAccountableBank = getMainAccountableBank(connectors as Connector[]);

  const taxReserveAccountableBank = getTaxSavingsAccountableBank(
    connectors as Connector[],
  );

  return {
    mainAccountableBank,
    taxReserveAccountableBank,
    isLoading: isLoadingConnectors,
  };
};

export default useAccountableBanks;
